// Historical upload URLs -> their /elakay_api/files/<zone>/<name> path.
// Dependency-free on purpose: used by src/config.js (toImageUrl) and
// src/utils/fileUrl.js. Mirrors server_elakay/elakay_helpers/storagePaths.js.
const LEGACY = [
  [/^\/data\/images\/app-pwa\/default\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/app-pwa-default/${m[1]}`],
  [/^\/data\/images\/app-pwa\/default$/, () => "/elakay_api/files/app-pwa-default"],
  [/^\/data\/images\/app-pwa\/custom\/([A-Za-z0-9_-]+)(\/[A-Za-z0-9._-]+)?$/, (m) => `/elakay_api/files/app-pwa/${m[1]}${m[2] || ""}`],
  [/^\/data\/images\/layout-backgrounds\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/layout-backgrounds/${m[1]}`],
  [/^\/data\/images\/email-marketing\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/email-marketing/${m[1]}`],
  [/^\/data\/images\/how-we-do-it\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/hwdi-images/${m[1]}`],
  [/^\/data\/videos\/how-we-do-it\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/hwdi-videos/${m[1]}`],
  [/^\/data\/files\/how-we-do-it\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/hwdi-files/${m[1]}`],
  [/^\/data\/images\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/chatbot-images/${m[1]}`],
  [/^\/data\/videos\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/chatbot-videos/${m[1]}`],
  [/^\/media\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/media/${m[1]}`],
  [/^\/documents\/([A-Za-z0-9._-]+)$/, (m) => `/elakay_api/files/documents/${m[1]}`],
];

// Path of the canonical API URL, or null when `pathname` is not an uploaded file.
export const legacyFilePath = (pathname) => {
  let decoded = pathname;
  try { decoded = decodeURIComponent(pathname); } catch (_) { /* keep raw */ }
  for (const [pattern, build] of LEGACY) {
    const match = pattern.exec(decoded);
    if (match) return build(match);
  }
  return null;
};

